import { makeApiCall } from "../config"
import { ErrorToaster, successToaster } from "../utils/toaster";

export async function createFreeTrail() {
    try {
        const response = await makeApiCall("/api/v1/subscription/freetrial", 'post');
        const { data, message } = response;
        successToaster(message);
        return data;
    } catch (error) {
        if (error.response && error.response.status === 422) {
            ErrorToaster(error.response.data.message);
        } else {
            console.log("Error occurred in createFreeTrail form", error);
        };
        return false;
    };
};

export async function checkTrail(userId) {
    try {
        const response = await makeApiCall("/api/v1/subscription/checktrial", 'get', null, {userId: userId});
        const { message } = response;
        // successToaster(message);
        return response;
    } catch (error) {
        if (error.response && error.response.status === 422) {
            ErrorToaster(error.response.data.message);
        } else {
            console.log("Error occurred in checkTrail", error);
        };
        return false;
    };
};
